<script setup lang="ts">
// components
import CiModalHeader from '@/components/CiModal/CiModalHeader.vue';
import CiSlotContent from '@/components/slots/CiSlotContent.vue';

export interface CiReviewModalGuidelinesProps {
  title?: string | null;
  closeable?: boolean;
}
const props = withDefaults(defineProps<CiReviewModalGuidelinesProps>(), {
  title: null,
  closeable: true,
});

const emit = defineEmits<{
  close: [];
}>();
</script>

<template>
  <div class="rounded bg-white shadow-2xl">
    <CiModalHeader
      :title="props.title"
      :closeable="props.closeable"
      @modal-close="props.closeable ? emit('close') : false"
    />
    <div class="modal-body mt-4 px-2">
      <CiSlot-Content
        :extra="{ type: 'wide' }"
        slug="guidelines"
      />
    </div>
  </div>
</template>
